<template>
  <div
    id="seasidetms_row_pe44dbegjn"
    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
  >
    <div class="seasidetms_row_outer_parent">
      <div class="seasidetms_row_outer">
        <div class="seasidetms_row_inner">
          <div
            class="seasidetms_row_margin seasidetms_row_columns_behavior seasidetms_1212"
          >
            <div
              id="seasidetms_column_s348hg2jzt"
              class="seasidetms_column one_half seasidetms_adaptive_margin_column fadeInLeft animated photo-banners"
              data-animation="fadeInLeft"
              data-delay="500"
            >
              <router-link
                :to="
                  lang
                    ? '/' + lang + '/product-category/gadgets/apple-airpods'
                    : '/product-category/gadgets/apple-airpods'
                "
              >
                <div class="seasidetms_column_inner">
                  <div
                    id="seasidetms_heading_6aedbwp0a"
                    class="seasidetms_heading_wrap seasidetms_heading_align_right"
                  >
                    <div class="seasidetms_heading">
                      <router-link
                        :to="
                          lang
                            ? '/' +
                              lang +
                              '/product-category/gadgets/apple-airpods'
                            : '/product-category/gadgets/apple-airpods'
                        "
                        >Apple AirPods</router-link
                      >
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div
              id="seasidetms_column_0o26ejoej"
              class="seasidetms_column one_half fadeInRight animated photo-banners"
              data-animation="fadeInRight"
              data-delay="500"
            >
              <router-link
                :to="
                  lang
                    ? '/' + lang + '/product-category/apple-watch/'
                    : '/product-category/apple-watch/'
                "
              >
                <div class="seasidetms_column_inner">
                  <div
                    id="seasidetms_heading_f5bkryu10s"
                    class="seasidetms_heading_wrap seasidetms_heading_align_left"
                  >
                    <div class="seasidetms_heading">
                      <router-link
                        :to="
                          lang
                            ? '/' + lang + '/product-category/apple-watch/'
                            : '/product-category/apple-watch/'
                        "
                      >
                        Apple Watch
                      </router-link>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoBanners',
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style></style>
